<ng-template>
  <ng-content/>
</ng-template>
